import React, { useEffect, useState } from "react";
import { Button, Flex, Table } from "antd";
import {
  PlusCircleFilled,
  SearchOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchEquipmentList,
  addSelectedPart,
  removeSelectedPart,
} from "../../redux/actions/action";
import styles from "./partListPopup.module.css";
import tool from "../../assets/icons/tool.svg";
import aperture from "../../assets/icons/aperture.svg";
import location from "../../assets/icons/location1.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

function PartListPopup() {
  const dispatch = useDispatch();

  const fetchParticularAsset = useSelector(
    (state) => state.user.fetchParticularAsset
  );
  const equipmentPartList = useSelector((state) => state.user.equipmentList);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [isGroupModal, setIsGroupModal] = useState(false);
  const [selectedParts, setSelectedParts] = useState([]);
  const [allpartList, setAllPartList] = useState([]);

  useEffect(() => {
    dispatch(FetchEquipmentList());
  }, []);

  useEffect(() => {
    const partListArray = equipmentPartList.map((asset) => {
      return {
        partId: asset.assetId,
        type: asset.assetType,
        name: asset.assetName,
        quantity: 0,
        unitCost: 0,
        totalCost: 0,
      };
    });
    setAllPartList(partListArray);
  }, [equipmentPartList]);

  const showModal = () => {
    setIsGroupModal(true);
  };

  const handleCancel = () => {
    setIsGroupModal(false);
    setEquipmentAndPartSearch("");
  };

  const handleCheckboxChange = (e, record) => {
    if (e.target.checked) {
      // If checkbox is checked, add to the array
      setSelectedParts([...selectedParts, record]);
      dispatch(addSelectedPart(record));
    } else {
      // If checkbox is unchecked, remove from the array
      // setSelectedParts(selectedParts.filter((part) => part.partId !== record.partId));
      dispatch(removeSelectedPart(record.partId));
    }
  };

  const savedParts = useSelector((state) => state.user.selectedParts);
  console.log("asc33 parts", savedParts);

  const partTableColumn = [
    {
      title: "",
      dataIndex: "partId",
      key: "partId",
      render: (text, record) => {
        const isChecked = savedParts?.some(
          (item) => item.partId === record.partId
        );
        return (
          <div className="custom-checkbox-wrap">
            <input
              type="checkbox"
              className={`checkboxQuery-${record.partId}`} // Assign a unique class.
              checked={isChecked}
              onChange={(e) => handleCheckboxChange(e, record)}
            />
            <span className="checkmark"></span>
          </div>
        );
      },
    },
    {
      title: "",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div
          className={styles.icon_text}
          onClick={() => {
            setTimeout(() => {
              // Trigger a click event on the element with the class 'fas fa-bars'.
              const targetElement = document.querySelector(
                `.checkboxQuery-${record.partId}`
              );
              console.log("asc44", targetElement);
              if (targetElement) {
                targetElement.click(); // Simulate a click event.
              } else {
                console.log('Element with class "profileButton" not found.');
              }
            }, 10);
          }}
        >
          <div className={styles.icon_wrap}>
            <img src={getImageSource(record.type)} alt="part icon" />
          </div>
          {text}
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "type",
      key: "type",
      render: (text, record) => (
        <div className={styles.icon_text}>
          <div className={styles.icon_wrap}>
            <img src={getImageSource(record.type)} alt="part icon" />
          </div>
          {text}
        </div>
      ),
    },
  ];

  const getImageSource = (type) => {
    // Add your logic to map part types to image sources
    switch (type) {
      case "Equipment":
        return aperture;
      case "Part":
        return tool;
      case "Facility":
        return location;
      // Add more cases as needed
    }
  };

  const [equipmentAndPartSearch, setEquipmentAndPartSearch] = useState("");

  return (
    <>
      <div className={styles.add_part_wrap}>
        <Button
          onClick={showModal}
          type="text"
          icon={<PlusCircleFilled style={{ color: "#95a7c6" }} />}
        >
          {/* Add Part */}
          {t("Add Part")}
        </Button>
        <div
          className={`${styles.addPartPopup} ${
            isGroupModal ? styles.show : ""
          }`}
        >
          <div className={styles.part_popup_inner}>
            <div className={styles.part_popup_header}>
              <div className={styles.title_wrap}>
                <Flex gap="small" className={styles.flex}>
                  <h2>
                    {/* Equipments & Parts */}
                    {t("Equipments & Parts")}
                  </h2>
                  <div className={styles.list_toggle_btn}>
                    <div className={styles.btn_wrap}>
                      <button type="button" className={styles.active_btn}>
                        {/* List */}
                        {t("List")}
                      </button>
                      <button type="button">
                        {/* Tree */}
                        {t("Tree")}
                      </button>
                    </div>
                  </div>
                  <div className={styles.search_input}>
                    <input
                      type="text"
                      placeholder="Search"
                      value={equipmentAndPartSearch}
                      onChange={(e) => {
                        setEquipmentAndPartSearch(e.target.value);
                      }}
                    />
                    <Button
                      type="text"
                      shape="circle"
                      icon={<SearchOutlined />}
                    />
                  </div>
                </Flex>
              </div>
              <div className={styles.close_btn_wrap}>
                <Button
                  type="text"
                  shape="circle"
                  icon={<CloseCircleOutlined />}
                  onClick={handleCancel}
                />
              </div>
            </div>
            <div className={styles.popup_body}>
              <div className={`${styles.table_wrapper} part-table-wrapper`}>
                <Table
                  columns={partTableColumn}
                  dataSource={allpartList.filter((item) =>
                    item?.name
                      .toLowerCase()
                      .includes(equipmentAndPartSearch.toLowerCase()),
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PartListPopup;
